import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';

import { RiskName } from './filters/RiskName';
import { RiskSeverity } from './filters/RiskSeverity';
import { RiskStatus } from './filters/RiskStatus';

/**
 * Get simple filter definitions for Risk entity
 * Returns field names mapped to available values and operators
 *
 * @returns Map of field names to SimpleFieldDefinition
 */
export function getRiskSimpleFilters(): SimpleFilterDefinition[] {
  return [RiskStatus, RiskSeverity, RiskName];
}
